module.exports = __webpack_public_path__ + "static/media/projects2.427b2887.png";